<template>
  <section
    class="section section-primary is-fullheight animated preFadeInUp fadeInUp"
  >
    <div class="container">
      <!-- Title -->

      <div class="columns is-centered has-text-centered" v-if="requestloading">
        <loading
          line-fg-color="#2d3f51"
          size="massive"
          class="margin-100"
          spacing="55"
          text-fg-color="#fff"
          message="الرجاء الإنتظار"
        />
      </div>
      <div
        class="columns is-vcentered"
        v-else-if="!ischargeconfirmed && !requestloading && failmessage != ''"
      >
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div class="flex-card raised padding-20">
            <div class="square-icon-box rounded danger mt-20">
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">close</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInLeft fadeInLeft pb-90">
              <hr />

              <h1 class="subtitle is-5">{{ failmessage }}</h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
      <div
        class="columns is-vcentered"
        v-if="ischargeconfirmed && !requestloading && !requestsuccess"
      >
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded info mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">credit_card</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />

              <label class="label is-medium">
                رجاء ادخال رقم البطاقة
                <br />
                ل{{ requeststring }}
              </label>

              <div class="field-body">
                <div class="field has-addons is-fullwidth">
                  <p class="control is-expanded">
                    <input
                      v-model="requestInfo.CardNumber"
                      name="CardNumber"
                      class="input has-text-centered is-large"
                      autofocus
                      placeholder="رقم البطاقة"
                      v-validate="{
                        required: true,
                        numeric: true,
                        min: 16,
                        max: 16,
                      }"
                    />
                  </p>

                  <!-- <p class="control is-expanded">
                    <input
                      class="input has-text-centered is-large"
                      type="text"
                      autofocus
                      value="4587872"
                      disabled
                      placeholder="اول ثمانية ارقام في بطاقة"
                      v-validate="{ required: true, numaric: true }"
                    />
                  </p> -->
                </div>
              </div>
              <span
                v-show="errors.has('CardNumber')"
                class="help is-danger is-centered"
                >{{ errors.first("CardNumber") }}</span
              >
              <!-- <div class="control mb-10">
                  <span
                    v-show="errors.has('chargevalue')"
                    class="help is-danger is-centered"
                  >{{ errors.first('chargevalue') }}</span>

                  <hr>
                  الحد الأقصي ل{{requeststring }} هو
                  <span
                    class="tag is-warning is-bold has-text-black is-large has-text-bold"
                  >${{ maxvalue }}</span>
                  <br>

                  <p>
                    عدد افراد الاسرة :
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >{{ familyMembersCount }}</span> قيمة للفرد:
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >${{amountPerPerson}}</span>
                    <br>رصيد الحساب الجاري بدينار:
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >{{CustomerBalance}} د.ل</span>- سعر الصرف:
                    <span
                      class="tag is-light is-bold has-text-black is-large has-text-bold"
                    >{{exChangeRate}}</span>
                  </p>
              </div>-->
              <div class="field mt-20">
                <label class="label is-medium"
                  >رقم الهاتف المرتبط بالرقم الوطني</label
                >

                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-large has-text-centered is-english"
                        v-model="requestInfo.mobileNo"
                        v-validate="{
                          required: true,
                          numeric: true,
                          regex: /^09\d{8}$/,
                        }"
                        type="text"
                        placeholder="الهاتف النقال"
                        name="mobileNo"
                        :class="{
                          input: true,
                          'is-danger': errors.has('mobileNo'),
                        }"
                      />
                    </div>
                    <span
                      v-show="errors.has('mobileNo')"
                      class="help is-danger is-centered"
                      >{{ errors.first("mobileNo") }}</span
                    >
                  </div>
                </div>
              </div>
              <div class="field mt-5">
                <label class="label is-medium">المخصصات عن الفترة</label>

                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <div class="select is-fullwidth is-medium">
                        <select
                          class="select"
                          v-validate="'required'"
                          v-model="selectedversion"
                          name="version"
                          oninput="setCustomValidity('')"
                          placeholder="الصرفة"
                          :onchange="getNotes()"
                        >
                          <option selected disabled :value="null">
                            رجاء اختيار المخصص
                          </option>
                          <option
                            v-for="version in versions"
                            v-bind:key="version.id"
                            v-bind:value="version.id"
                          >
                            {{ version.name }}
                          </option>
                        </select>
                      </div>
                      <span
                        v-show="errors.has('version')"
                        class="help is-danger is-centered"
                        >{{ errors.first("version") }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <b-message
                v-if="chargenote"
                title="تنبيه"
                :closable="false"
                :type="'is-warning'"
                class="pb-5 pt-20"
                >{{ chargenote }}</b-message
              >

              <div class="field" v-if="selectedversion">
                <label class="label is-medium">القيمة</label>

                <div class="field-body">
                  <div class="field">
                    <div class="control">
                      <input
                        class="input is-large has-text-centered is-english"
                        v-model="requestInfo.amount"
                        v-validate="{
                          required: true,
                          numeric: true,
                          min_value: 1,
                        }"
                        type="text"
                        placeholder="القيمة"
                        name="amount"
                        :class="{
                          input: true,
                          'is-danger': errors.has('amount'),
                        }"
                      />
                    </div>
                    <span
                      v-show="errors.has('amount')"
                      class="help is-danger is-centered"
                      >{{ errors.first("amount") }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
            <hr />
            <div
              class="hero-foot has-text-centered mt-20 mb-20 px-15"
              v-if="selectedversion"
            >
              <a
                class="button btn secondary-btn raised btn-align modal-dismiss is-bold is-medium"
                v-on:click="validateBeforeSubmit()"
              >
                <b>تأكيد رقم البطاقة والاستمرار</b>
              </a>
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-40 mb-40 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>

      <div class="columns is-vcentered" v-else-if="requestsuccess">
        <div class="column is-6 is-offset-3 mb-90">
          <!-- Login form -->
          <div
            class="flex-card raised padding-20 animated preFadeInUp fadeInUp pb-90"
          >
            <div
              class="square-icon-box rounded primary mt-20 animated preFadeInUp fadeInUp"
            >
              <div class="icon-box-wrapper">
                <div class="icon-box">
                  <i class="material-icons">check</i>
                </div>
              </div>
            </div>
            <div class="animated preFadeInUp fadeInUp pb-90">
              <hr />
              <h1 class="title is-4 pb-10">
                تم ارسال طلب {{ requeststring }} بنجاح
              </h1>

              <h1 class="subtitle is-5">
                سيتم تنبيهك عند الانتهاء من معالجة طلبك
              </h1>

              <hr />
            </div>
          </div>
          <div
            class="hero-foot has-text-centered mt-20 mb-20 animated preFadeInUp fadeInUp"
          >
            <a
              class="button is-dark btn-align modal-dismiss is-bold is-medium"
              @click="$router.go('-1')"
            >
              <b>العودة</b>
            </a>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import arabic from "vee-validate/dist/locale/ar";

export default {
  props: ["requeststring", "requestid"],

  data() {
    return {
      requestloading: false,
      requestsuccess: false,
      CustomerBalance: "",
      exChangeRate: "",
      familyMembersCount: "",
      amountPerPerson: "",
      chargevalue: null,
      failmessage: "",
      ischargeconfirmed: true,
      userid: null,
      chargenote: null,
      requestInfo: {
        Customer_Id: null,
        CardNumber: "",
        mobileNo: "",
        Notes: "new request",
        amount: "",
      },
      preinfo: {
        status: true,
      },
      versions: {},
      selectedversion: null,
    };
  },
  methods: {
    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          console.log("check triggered");
          this.sendrequest();
          return;
        }
      });
    },
    checkFcp() {
      this.requestloading = true;

      axios
        .post("/personalfcp/PreRequestInfo_v2/", {
          Customer_Id: this.requestInfo.Customer_Id,
          amountPerPersonValuesId: this.selectedversion,
        })
        .then((response) => {
          this.$root.kick(response.data.message);
          console.log(response.data);
          this.$root.kick(response.data.message);

          if (response.data.status == "success") {
            console.log("request triggered");
            this.sendrequest();
          } else {
            this.failmessage = response.data.message;
            this.ischargeconfirmed = false;
            this.requestloading = false;
          }
        })
        .catch((error) => {});
    },
    getNotes() {
      // this.requestloading=true;

      if (this.selectedversion != null) {
        // this.requestloading = true;

        this.requestInfo.amountPerPersonValuesId = this.selectedversion;

        axios
          .post("personalfcp/instructions", this.requestInfo)
          .then((response) => {
            // console.log(response.data);

            this.chargenote = response.data.message;

            this.$root.kick(response.data.message);
          })
          .catch((error) => {});
      }
    },
    sendrequest() {
      // this.requestloading=true;
      this.requestloading = true;
      this.ischargeconfirmed = true;
      this.requestInfo.amountPerPersonValuesId = this.selectedversion;

      axios
        .post("personalfcp/newRequest_v2", this.requestInfo)
        .then((response) => {
          console.log("requestsent");

          console.log(response.data);

          this.$root.kick(response.data.message);

          if (response.data.status === "success") {
            this.requestloading = false;
            this.ischargeconfirmed = true;
            this.requestsuccess = true;
          } else if (response.data.status === "fail") {
            this.failmessage = response.data.message;
            this.ischargeconfirmed = false;
            this.requestloading = false;
          }
          // console.log(response);
        })
        .catch((error) => {});
    },
  },
  created() {},
  mounted() {
    this.$validator.localize("ar", {
      messages: arabic.messages,
      attributes: {
        CardNumber: "رقم البطاقة",
        version: "المخصصات عن الفترة",
        mobileNo: "الهاتف النقال",
        amount: "القيمة",
      },
      custom: {
        mobileNo: {
          regex: "رقم الهاتف يجب ان يبدا ب(09) ويليه ثمان ارقام ",
        },
      },
    });

    var user = JSON.parse(localStorage.getItem("user"));

    this.requestInfo.Customer_Id = user[1];

    axios
      .post("/personalfcp/FCBValues/", this.preinfo)
      .then((response) => {
        this.$root.kick(response.data.message);
        this.versions = response.data.data;
      })
      .catch((error) => {});
  },
};
</script>
